import List from 'list.js';
import noUiSlider from 'nouislider';

export default class ExplorerList {
  constructor(items = []) {
    this.items = items;

    // area slider

    // initial values from post
    const initialValues = document.getElementById('area-input').value.split(',');

    const areaSliderOptions = {
      start: Array.isArray(initialValues) && initialValues.length === 2 ? initialValues : [25, 50],
      step: 1,
      connect: true,
      tooltips: [
        {
          to: function (numericValue) {
            return `od ${Math.ceil(numericValue)} m&sup2;`;
          },
        },
        {
          to: function (numericValue) {
            return `do ${Math.ceil(numericValue)} m&sup2;`;
          },
        },
      ],
      range: {
        min: 20,
        max: 56,
      },
    };

    const areaSlider = noUiSlider.create(document.getElementById('area'), areaSliderOptions);

    this.areaSlider = areaSlider;

    // list
    const options = {
      valueNames: ['localNumber', 'area', 'rooms', 'floor', { name: 'statusId', attr: 'data-status-id' }, 'price'],
      page: 30,
      pagination: {
        innerWindow: 2,
        outerWindow: 2,
        item: `<li><span class="page"></span></li>`,
      },
      item: this.itemTemplate.bind(this),
    };

    this.list = new List('listing-list', options, items);

    this.filterItems();

    // layover
    this.layover = document.querySelector('.page-explorer--layover');
    this.layoverMessageField = this.layover.querySelector('[name="your-message"]');
  }

  init() {
    this.listeners();
  }

  itemTemplate(values) {
    const priceLabel =
      values.price == 0
        ? '-'
        : `${parseFloat(values.price).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })} zł`;

    return `
    <li>
      <span data-title="Apartament" class="local-number">${values.localNumber}</span>
      <span data-title="Metraż" data-area="${values.area}">${values.area} m&sup2;</span>
      <span data-title="Liczba pokoi" class="rooms"></span>
      <span data-title="Piętro" class="floor"></span>
      <span data-title="Status" data-status-id="${values.statusId}">${this.itemStatus(values.statusId)}</span>
      <span data-title="Cena" data-price="${values.price}">${priceLabel}</span>
      <span>
        <a href="${values.cardUrl}" class="btn-card" target="_blank">
          <svg width="38" height="40" viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0387 25.4481C17.2251 25.2246 17.3194 24.9392 17.3029 24.6486V24.0231V23.4045V23.4049C17.3168 23.1154 17.2141 22.8325 17.0178 22.6194C16.7948 22.4337 16.5082 22.3417 16.2187 22.3622H15.4263V25.6983H16.2606C16.5431 25.7225 16.8234 25.6327 17.0387 25.4481V25.4481Z" fill="#C8A370"/>
            <path d="M9.8871 22.3154H8.95605V23.7462L9.8871 23.7466C10.0818 23.7568 10.2732 23.6923 10.4217 23.5658C10.5581 23.4253 10.6289 23.2335 10.6164 23.0381C10.6256 22.8452 10.5611 22.6567 10.4357 22.5101C10.2901 22.3678 10.0895 22.297 9.88708 22.3153L9.8871 22.3154Z" fill="#C8A370"/>
            <path d="M35.6648 6.41875L31.6686 2.42262C30.6351 1.3843 29.2751 0.733888 27.8182 0.580887V0.539062H12.5285C11.4227 0.539062 10.3621 0.978592 9.57979 1.76043C8.79796 2.54263 8.35842 3.60329 8.35842 4.70914V10.9642C8.35842 11.3329 8.50481 11.6866 8.76566 11.9471C9.02615 12.208 9.37983 12.3543 9.74856 12.3543C10.1173 12.3543 10.4706 12.208 10.7315 11.9471C10.9919 11.6866 11.1383 11.3329 11.1383 10.9642V4.70914C11.1383 4.34041 11.2851 3.98711 11.5456 3.72624C11.8064 3.46575 12.1597 3.31936 12.5285 3.31936H26.429V7.48934C26.429 8.59509 26.8682 9.65576 27.6504 10.4377C28.4322 11.2199 29.4929 11.659 30.5991 11.659H34.7691L34.7687 35.2891C34.7687 35.6578 34.6223 36.0114 34.3618 36.2719C34.101 36.5328 33.7477 36.6792 33.3789 36.6792H12.529C12.1603 36.6792 11.807 36.5328 11.5461 36.2719C11.2857 36.0115 11.1389 35.6578 11.1389 35.2891V33.2044H27.8186C28.9248 33.2044 29.9854 32.7649 30.7673 31.9831C31.5495 31.2009 31.9887 30.1402 31.9887 29.0344V19.304C31.9887 18.1982 31.5495 17.1376 30.7673 16.3553C29.9855 15.5734 28.9249 15.1339 27.8186 15.1339H4.18863C3.08288 15.1339 2.02221 15.5734 1.23993 16.3553C0.458095 17.1375 0.0185547 18.1981 0.0185547 19.304V29.0344C0.0185547 30.1401 0.458086 31.2008 1.23993 31.9831C2.02212 32.7649 3.08278 33.2044 4.18863 33.2044H8.35861V35.2894V35.2891C8.35861 36.3952 8.79814 37.4559 9.57998 38.2378C10.3622 39.02 11.4228 39.4591 12.5287 39.4591H33.3786C34.4843 39.4591 35.545 39.02 36.3273 38.2378C37.1091 37.4559 37.5487 36.3953 37.5487 35.2891V10.964C37.549 9.25914 36.8714 7.62394 35.665 6.41863L35.6648 6.41875ZM30.5985 8.87905C30.2297 8.87905 29.8761 8.73266 29.6156 8.47218C29.3547 8.21133 29.2083 7.85764 29.2083 7.48928V4.01414C29.3841 4.13374 29.5492 4.26875 29.7018 4.41735L33.7049 8.42043C33.8399 8.56314 33.9628 8.7165 34.0732 8.87903L30.5985 8.87905ZM20.6877 21.3266C20.6859 21.2701 20.7057 21.2155 20.7435 21.1736C20.7762 21.138 20.8206 21.1157 20.8686 21.1109H24.7466C24.8658 21.1109 24.9623 21.2074 24.9623 21.3266V22.2094V22.209C24.9649 22.267 24.9421 22.3227 24.8996 22.362C24.8578 22.3998 24.8031 22.4199 24.7466 22.4177H22.2588V23.5785H24.6428L24.6424 23.5782C24.7617 23.5782 24.8578 23.6747 24.8578 23.7935V24.6763C24.8607 24.7342 24.838 24.79 24.7954 24.8292C24.7536 24.867 24.6989 24.8868 24.6424 24.8846H22.2588V26.7404C22.2599 26.7947 22.2397 26.8468 22.203 26.8864C22.1634 26.9282 22.1076 26.951 22.05 26.9491H20.8687C20.7549 26.9455 20.6639 26.8541 20.6603 26.7404L20.6877 21.3266ZM13.856 21.3266C13.8538 21.2701 13.874 21.2155 13.9118 21.1736C13.951 21.1311 14.0068 21.108 14.0648 21.1109H16.2609C16.9507 21.0687 17.6324 21.2786 18.179 21.7016C18.6442 22.1378 18.8974 22.7534 18.8739 23.3907V24.0302V24.6627C18.8137 26.1868 17.9567 26.9491 16.3024 26.9491H14.0648C13.9511 26.9455 13.8597 26.8541 13.856 26.7404L13.856 21.3266ZM8.99108 24.9405V26.7404C8.99218 26.7947 8.97237 26.8468 8.93532 26.8864C8.89643 26.929 8.84029 26.9518 8.78269 26.9492H7.57344C7.45971 26.9455 7.36835 26.8542 7.36468 26.7404V21.3266C7.36248 21.2701 7.38265 21.2155 7.42044 21.1736C7.4597 21.1311 7.51546 21.108 7.57343 21.1109H9.93653H9.93616C10.5437 21.076 11.1443 21.2503 11.6389 21.6044C12.0641 21.9602 12.2938 22.497 12.2575 23.0499C12.2857 23.5856 12.056 24.1025 11.6389 24.4401C11.1381 24.7787 10.5401 24.9445 9.93616 24.9126L8.99108 24.9405Z" fill="#C8A370"/>
          </svg>
        </a>
      </span>
      <span>
        <a href="#" class="btn-explorer" data-apartment-name="${values.localNumber}" style="visibility: ${
      [3, 4, 5, 6, 7, 8, 9].includes(parseInt(values.statusId)) ? 'hidden' : 'visible'
    }">Zapytaj o ofertę</a>
      </span>
    </li>`;
  }

  itemStatus(statusId) {
    switch (statusId) {
      case '1':
        return 'Dostępny';
      case '2':
        return 'Zarezerwowany';
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        return 'Sprzedany';
      default:
        return '-';
    }
  }

  listeners() {
    const form = document.querySelector('.explorer-list--filters form');

    form.addEventListener('submit', this.filterItems.bind(this));

    document.querySelector('.explorer-list--table').addEventListener('click', (e) => {
      if (!e.target.classList.contains('btn-explorer')) {
        return;
      }

      e.preventDefault();

      const { apartmentName } = e.target.dataset;

      this.openAndFillLayover(`Jestem zainteresowana/y apartamentem nr ${apartmentName}. Proszę o kontakt.`);
    });
  }

  filterItems(e) {
    if (e) {
      e.preventDefault();
    }

    const rooms = document.getElementById('rooms').value;
    const floor = document.getElementById('floor').value;

    const [areaFromRaw, areaToRaw] = this.areaSlider.get();
    const [areaFrom, areaTo] = [parseFloat(areaFromRaw), parseFloat(areaToRaw)];

    // filtering
    this.list.filter((item) => {
      const roomsCondition = ['all', 'alles'].includes(rooms) || rooms == item.values().rooms;
      const floorCondition = ['all', 'alles'].includes(floor) || floor == item.values().floor;
      const areaCondition = parseFloat(item.values().area) >= areaFrom && parseFloat(item.values().area) <= areaTo;

      if (roomsCondition && floorCondition && areaCondition) {
        return true;
      }

      return false;
    });
  }

  openAndFillLayover(message) {
    this.layover.classList.add('toggled');
    this.layoverMessageField.value = message;
  }
}
